export default __webpack_public_path__ + "static/media/moneymaker-thumbnail.c146ab5e.webp";